<template>
  <v-navigation-drawer app location="left" v-model="editdrawer" width="316" height="100%" class="k-app-sidebar"
    v-bind="etalage ? { inert: true } : {}">
    <div class="k-app-sidebar-top">
      <div class="k-app-sidebar-head d-flex" @click="$router.push('/bedrijfspagina')" style="cursor: pointer">
        <!-- Every layout mounts its own sidebar: the cached logo paints at once
             instead of fading in again on each route change. -->
        <v-img :src="`${configdata.url.cdn}/pages/${mainStore.companypage.logo}`" :max-width="is_mobile ? '140' : '170'"
          height="40" :transition="false" eager></v-img>
        <v-btn @click="$emit('close-drawer')" variant="text" icon class="ml-auto mt-n1" v-if="is_mobile">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
              d="M8.53329 25.3334L6.66663 23.4667L14.1333 16.0001L6.66663 8.53341L8.53329 6.66675L16 14.1334L23.4666 6.66675L25.3333 8.53341L17.8666 16.0001L25.3333 23.4667L23.4666 25.3334L16 17.8667L8.53329 25.3334Z"
              fill="#4E4E4E" />
          </svg>
        </v-btn>
      </div>
      <k-spacing :y="is_mobile ? '4' : '6'"></k-spacing>
      <div class="language-choose d-flex pa-4 px-6 pa-md-4 px-md-6">
        <div class="employer-switch pa-1 pr-3" :class="employerView ? 'active' : ''" v-if="
          checkRoleSwitch()
        ">
          <v-switch inset density="compact" :label="$i18n.locale == 'en' ? 'Employer' : 'Werkgever'"
            color="var(--company-primary)" :model-value="employerView" @update:model-value="setRole" />
        </div>
        <div class="ml-auto my-auto">
          <v-btn :class="entry.language == language.language
            ? 'language-btn lang-active pa-0   '
            : 'language-btn pa-0  '
            " class="ml-2 mt-n1" rounded="lg" v-for="entry in languages" :key="entry.title"
            @click="changeLocaleBottom(entry)">
            <flag :iso="entry.flag" v-bind:squared="false" />
          </v-btn>
        </div>
      </div>

      <div v-if="isAdmin" class="company-select">
        <v-autocomplete :items="adminPageItems" :loading="adminSearchLoading" item-title="companyname"
          item-value="id" variant="solo" :rounded="false" hide-details :no-filter="true"
          append-inner-icon="mdi-magnify" menu-icon="" persistent-placeholder :placeholder="$t('admin_page_search_ph')"
          v-model="current_page_id" :search="adminSearchText" @update:search="onAdminSearch"
          @focus="onAdminFocus" @blur="onAdminBlur" @update:modelValue="goToAdminPage" />
      </div>
      <div v-else-if="showCompanyPageSwitcher" class="company-select">
        <v-select :items="accessibleCompanyPages" :loading="current_page_id == null" item-title="companyname"
          item-value="id" variant="solo" :rounded="false" hide-details v-model="current_page_id"
          @update:modelValue="changeCompany">
          <template #selection="{ item }">
            {{ (item && item.raw && item.raw.companyname) || mainStore.companypage.companyname }}
          </template>
        </v-select>
      </div>
    </div>

    <div class="k-app-sidebar-body mt-2">
      <v-list nav color="var(--company-primary)" class="pa-0">
        <v-list-item-group>
          <v-list-item link class="mb-0 sidebar-link" :class="isSidebarItemActive(item.to) ? 'active-sidebar' : ''"
            v-for="item in sidebar_items" :key="item.title" :to="item.to" rounded="xl" color="var(--company-primary)">
            <template v-slot:prepend>
              <v-icon :icon="item.icon"></v-icon>
            </template>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <div class="k-app-sidebar-extras mt-auto" v-if="mainStore.user.id != -1 || anonymousEtalage">
      <div class="pa-2" v-if="mainStore.companypage.settings?.credits > 0">
        <CreditsCard @open-dialog="credits_dialog = true" @close-dialog="credits_dialog = false" />
      </div>
      <div v-if="!is_mobile" class="pa-3 pa-md-5">
        <k-app-logo style="cursor: pointer" width="170"></k-app-logo>
      </div>
    </div>

    <div class="k-app-sidebar-footer" v-if="mainStore.user.id != -1 || anonymousEtalage">
      <v-divider></v-divider>
      <v-list lines="two">
        <!-- Beside the Etalage nobody is logged in (ADR-0069): the Gebruikersrij
             keeps its place and shape, without a naam, e-mailadres or uitlogknop. -->
        <v-list-item v-if="anonymousEtalage" class="footer-user-item footer-user-placeholder" aria-hidden="true">
          <template v-slot:prepend>
            <v-avatar color="var(--company-primary)" size="48"
              :image="`${configdata.url.cdn}/default_images/default_avatar_image.png`"></v-avatar>
          </template>
          <div class="footer-user-placeholder-bar"></div>
          <div class="footer-user-placeholder-bar footer-user-placeholder-bar--short"></div>
        </v-list-item>
        <v-list-item v-else class="footer-user-item" :title="userFullName"
          :subtitle="mainStore.user.email" @click="$router.push('/accountgegevens')">
          <template v-slot:prepend>
            <v-avatar style="cursor: pointer" @click.stop="$router.push('/accountgegevens')"
              color="var(--company-primary)" size="48"
              :image="`${configdata.url.cdn}/users/avatars/${mainStore.user.profilepicture}`"></v-avatar>
          </template>

          <template v-slot:append>
            <v-btn @click.stop.prevent="signout()" color="#696969" icon="mdi-logout" variant="text"></v-btn>
          </template>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>

  <v-dialog v-model="credits_dialog" width="560">
    <CreditsOverviewDialog class="credits-overview-dialog" @close-dialog="credits_dialog = false" />
  </v-dialog>
</template>

<script>
import { useMainStore } from "@/stores/store";
import config from "@/config";
const cookies = require("js-cookie");

import api from "../../../services/api";
import PageService from "@/services/PageService";

import CreditsCard from "@/components/credits-card.vue";
import CreditsOverviewDialog from "@/components/dialogs/credits-overview-dialog.vue";
import {
  findAccessibleCompanyPage,
  getAccessibleCompanyPages,
  shouldShowCompanyPageSwitcher,
} from "@/util/CompanyPageSwitcherUtil";
import isMobile from "@/mixins/isMobile";
import { fullNameFor } from "@/util/participants";
import { offersViewRoleSwitch, showsIntakeForms } from "@/util/intakeFormAccess";
import { routeAvailable } from "@/util/integrations";

export default {
  mixins: [isMobile],
  // setup() {
  // 	const mainStore = useMainStore();

  // 	return {
  // 		name: mainStore.user.firstname + " " + mainStore.user.lastname,
  // 		profilepicture: mainStore.user.profilepicture,
  // 		userMail: mainStore.user.email,
  // 		company_logo: mainStore.companypage.logo,
  // 	};
  // },

  components: {
    CreditsCard,
    CreditsOverviewDialog,
  },

  data() {
    return {
      // Access the route query here

      mainStore: useMainStore(),

      editdrawer: false,
      languages: [
        { flag: "nl", language: "nl" },
        { flag: "gb", language: "en" },
      ],

      language: {
        flag: "nl",
        language: "nl",
        title: "NL",
      },

      admin_items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          to: "/",
        },
        {
          title: "Inschrijven",
          icon: "mdi-briefcase-outline",
          to: "/bedrijfspagina",
        },
        {
          title: "Intakeformulieren",
          icon: "mdi-file-document-outline",
          to: "/intakeformulieren",
        },
        {
          title: "Accountgegevens",
          icon: "mdi-account-circle-outline",
          to: "/accountgegevens",
        },
        {
          title: "Contact",
          icon: "mdi-help-circle-outline",
          to: "/contact",
        },
      ],
      eng_admin_items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          to: "/",
        },
        {
          title: "Sign up",
          icon: "mdi-briefcase-outline",
          to: "/bedrijfspagina",
        },
        {
          title: "Intakeforms",
          icon: "mdi-file-document-outline",
          to: "/intakeformulieren",
        },
        {
          title: "Account details",
          icon: "mdi-account-circle-outline",
          to: "/accountgegevens",
        },
        {
          title: "Contact",
          icon: "mdi-help-circle-outline",
          to: "/contact",
        },
      ],
      mini: true,

      credits_dialog: false,

      current_page_id: null,

      // Admin-only page switcher (autocomplete over all bedrijfspaginas).
      adminPageItems: [],
      adminSearchLoading: false,
      adminSearchTimer: null,
      adminSearchText: "",
      adminNavigating: false,
    };
  },
  computed: {
    configdata() {
      return config;
    },
    // Never glue the halves together by hand: a user row whose firstname is
    // null used to render the literal string "null Test" here.
    userFullName() {
      return fullNameFor(this.mainStore.user);
    },
    accessibleCompanyPages() {
      return getAccessibleCompanyPages(this.mainStore.user);
    },
    showCompanyPageSwitcher() {
      return shouldShowCompanyPageSwitcher(this.mainStore.user);
    },
    isAdmin() {
      return this.mainStore.user.role === "admin";
    },
    // Intakeformulieren are the werkgever's: a medewerker (role user) never gets
    // the item, and neither does a werkgever or admin with the Werkgever-switch
    // off -- that weergave shows only the medewerker menu.
    // Hidden until the user lands, so a medewerker never sees it flash by.
    canManageIntakeForms() {
      return showsIntakeForms(this.mainStore.user);
    },
    // Straight from the store, never a local copy: main.js seeds it once the
    // user lands (util/viewRole.js), which is often after this sidebar mounted.
    employerView() {
      return this.mainStore.user.updating_role === "employer";
    },
    // Beside the Etalage (ADR-0069) the sidebar is a new medewerker's: the member
    // menu, the credits-kaart at nothing spent, and a Gebruikersrij without anyone in it.
    anonymousEtalage() {
      return this.etalage && this.mainStore.user.id == -1;
    },
    logged_out_items() {
      return [
        {
          title: this.$i18n.locale == "nl" ? "Inschrijven" : "Sign up",
          icon: "mdi-briefcase-outline",
          to: `/openbare-pagina?link=${this.$route.query.link}`,
        },
      ];
    },
    // Not filtered on the page's subscription (Zoho's "Actieve
    // inschrijvingsmanager"): nothing the server serves or books asks for it,
    // so a medewerker and a werkgever keep Dashboard and Inschrijven (ADR-0087).
    sidebar_items() {
      const mainStore = useMainStore();
      if (mainStore.companypage.data != undefined) {
        const shouldShowCompanyPageItem = this.mainStore.companypage.status == "gepubliceerd";
        // A session whose /v1/users/me/info has not landed yet is a member all the
        // same: without this every cold start showed the logged-out menu first.
        const hasSession = !!(cookies.get("fmw_refresh_token") || cookies.get("fmw_access_token"));
        if (mainStore.user.id == -1 && !this.etalage && !hasSession) {
          return this.logged_out_items;
        } else {
          const items = this.$i18n.locale == "nl" ? this.admin_items : this.eng_admin_items;
          return items.filter(
            (item) =>
              (item.to !== "/bedrijfspagina" || shouldShowCompanyPageItem) &&
              (item.to !== "/intakeformulieren" || this.canManageIntakeForms) &&
              routeAvailable(this.$router.resolve(item.to))
          );
        }
      } else {
        return [];
      }
    },
  },
  watch: {
    drawer() {
      this.editdrawer = this.drawer;
    },
    editdrawer(newVal) {
      this.$emit("open-drawer", newVal);
      if (!newVal) {
        this.$emit("close-drawer");
      }
    },
    "mainStore.companypage.id"() {
      this.seedAdminSwitcher();
    },
    "mainStore.user.id"() {
      // user (and therefore isAdmin) can resolve after mount — reseed so the
      // admin switcher never renders with empty items and a raw id.
      this.seedAdminSwitcher();
    },
  },
  props: {
    drawer: Boolean,
    // Stands beside an Etalage (ADR-0069): inert, and for a visitor without a
    // session the navigation a new medewerker would have.
    etalage: Boolean,
  },

  mounted() {
    // set the current page id to the companypage id
    this.current_page_id = this.mainStore.companypage.id;

    // Seed the admin switcher with the current page so it always shows the
    // company name (never the raw id) even if user/companypage resolve after
    // mount. A watcher reseeds it if that data arrives late.
    this.seedAdminSwitcher();

    this.editdrawer = this.drawer;
    this.language.language = this.$i18n.locale;
  },
  methods: {
    checkRoleSwitch() {
      // Not on the page's subscription either (ADR-0087).
      return offersViewRoleSwitch(this.mainStore.user);
    },
    isSidebarItemActive(to) {
      const path = this.$route.path;

      if (to == "/bedrijfspagina") {
        // Active on bedrijfspagina OR activiteiten/:id (but not /aanmeldingen)
        if (path.includes("/aanmeldingen")) {
          return false;
        }
        return (
          path.startsWith("/bedrijfspagina") ||
          path.startsWith("/activiteiten/")
        );
      }

      if (to == "/") {
        // Dashboard active when on activiteiten/:id/aanmeldingen
        return (
          path.includes("/activiteiten/") && path.includes("/aanmeldingen")
        );
      }

      // Default Vue Router matching
      return path === to;
    },

    changeLocaleBottom(language) {
      if (language.language == "nl") {
        this.language = { flag: "nl", language: "nl", title: "NL" };
        this.$i18n.locale = "nl";
      } else {
        this.language = { flag: "gb", language: "en", title: "EN" };
        this.$i18n.locale = "en";
      }
      if (cookies.get("fmw_refresh_token")) {
        let updating_user = this.mainStore.user;
        updating_user.language = language.language;
        api.patch(`${config.url.api}/v1/users/0`, updating_user).then(() => { });
      }
    },

    setRole(isEmployer) {
      const role = isEmployer ? "employer" : "user";
      api
        .post(`${config.url.api}/v1/users/0/user_meta`, {
          type: "updating_role",
          value: role,
        })
        .then(() => { });
      this.mainStore.$patch({ user: { updating_role: role } });
    },

    updateUserRole(value) {
      this.user_role = value;
    },

    seedAdminSwitcher() {
      // Keep the current page bound and present in the items list so the
      // autocomplete always resolves current_page_id to a name.
      const page = this.mainStore.companypage;
      if (!page || !page.id) return;
      this.current_page_id = page.id;
      this.adminSearchText = page.companyname || "";
      if (!this.adminPageItems.some((p) => p && p.id == page.id)) {
        this.adminPageItems = [page, ...this.adminPageItems];
      }
    },

    onAdminFocus() {
      // Clear the field on focus so it reads as a search box (placeholder
      // shows) instead of a single-option dropdown, and surface the full list.
      // The bound selection must be cleared too, or Vuetify re-renders the
      // current page's name over the empty search.
      this.adminNavigating = false;
      this.current_page_id = null;
      this.adminSearchText = "";
      this.onAdminSearch("");
    },

    onAdminBlur() {
      // Restore the current page (name) if the user didn't pick anything.
      setTimeout(() => {
        if (this.adminNavigating) return;
        const page = this.mainStore.companypage;
        this.current_page_id = page && page.id ? page.id : null;
        this.adminSearchText = (page && page.companyname) || "";
      }, 150);
    },

    onAdminSearch(term) {
      // Debounced server-side search across all bedrijfspaginas (admin only).
      if (!this.isAdmin) return;
      this.adminSearchText = term || "";
      clearTimeout(this.adminSearchTimer);
      this.adminSearchTimer = setTimeout(() => {
        this.adminSearchLoading = true;
        PageService.searchPages(this.adminSearchText)
          .then((res) => {
            const results = Array.isArray(res.data.success)
              ? res.data.success
              : [];
            // Keep the current page in the list so a bound id always resolves
            // to a name if the field ever shows the selection.
            const page = this.mainStore.companypage;
            this.adminPageItems =
              page && page.id && !results.some((p) => p && p.id == page.id)
                ? [page, ...results]
                : results;
          })
          .catch(() => {})
          .finally(() => {
            this.adminSearchLoading = false;
          });
      }, 300);
    },

    goToAdminPage(pageId) {
      const page = this.adminPageItems.find((p) => p && p.id == pageId);
      if (!page || !page.domain) return;
      this.adminNavigating = true;
      // Admins are not page members, so the member-only /pages/active switch
      // does not apply — navigate straight to the page's subdomain.
      window.location.href = config.url.main.replace("{{domain}}", page.domain);
    },

    changeCompany(value) {
      const company = findAccessibleCompanyPage(this.mainStore.user, value);
      if (company) {
        this.mainStore.$patch({
          user: {
            ...this.mainStore.user,
            company: company.id,
          },
        });

        PageService.updateCompany(company.id).then((res) => {
          if (res.data.success) {
            window.location.href = res.data.redirect_url;
          }
        });
      }
    },

    redirect(item, type) {
      if (type == "link") {
        window.open(item, "_blank");
      } else {
        this.$router.push(item);
      }
    },

    signout() {
      api
        .put(`v1/auth/logout`, {
          refresh_token: cookies.get("fmw_refresh_token"),
        })
        .then((res) => {
          if (res.data.success) {
            cookies.remove("fmw_access_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("fmw_refresh_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("user", {
              domain: config.cookiedomain,
              path: "/",
            });
            let subdomain = location.hostname.split(".", 1);
            let config_login = config.url.login.replace(
              "{{domain}}",
              subdomain[0],
            );
            location.replace(`${config_login}/inloggen`);
          }
        })
        .catch((err) => {
          switch (err.response.status) {
            default:
              this.$toast.error("Oops, something went wrong");
              break;
          }
        });
    },
  },
};
</script>
<style>
.active-sidebar {
  caret-color: var(--company-primary) !important;
  color: var(--company-primary) !important;
}

.k-app-sidebar {
  height: 100%;
  display: flex;
}

.k-app-sidebar-head {
  padding-top: var(--spacing-6);
  padding-left: var(--spacing-6);
  padding-right: var(--spacing-3);
}

@media (max-width: 767.98px) {
  .k-app-sidebar-head {
    padding-top: var(--spacing-6);
    padding-left: var(--spacing-3);
    padding-right: var(--spacing-2);
  }

  .k-app-sidebar-body {
    padding: var(--spacing-2) !important;

    .sidebar-link {
      min-height: 45px !important;

      padding: 8px 16px !important;
    }
  }
}

.k-app-sidebar-body {
  padding-left: var(--spacing-3);
  padding-right: var(--spacing-3);

  .sidebar-link {
    .v-icon {
      width: 24px !important;
      height: 24px !important;
    }
  }
}

.k-app-sidebar-body .v-icon {
  opacity: 1 !important;
}

.k-app-sidebar-footer {

  width: 100%;
  padding: var(--spacing-0);
}

.v-list-item__prepend .v-list-item__spacer {
  width: 16px !important;
}

.k-app-sidebar-footer .v-list-item-title {
  font-size: 1.6rem;
  line-height: 1.6rem;
  font-weight: 600;
  color: var(--neutral-700, #4e4e4e);
}

.k-app-sidebar-footer .v-list-item-subtitle {
  color: var(--neutral-600, #696969);
  font-family: Open Sans;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.16rem;
}

/* The Gebruikersrij beside the Etalage (ADR-0069): its shape, nobody in it. */
.footer-user-placeholder-bar {
  height: 12px;
  width: 140px;
  border-radius: 6px;
  background: var(--neutral-200, #dfdfdf);
}

.footer-user-placeholder-bar + .footer-user-placeholder-bar {
  margin-top: 10px;
}

.footer-user-placeholder-bar--short {
  width: 96px;
}
</style>
